"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
const constants_1 = require("./constants");
const captcha_1 = require("./captcha/captcha");
const event_emitter_1 = require("../commons/event-emitter");
const debug_1 = __importDefault(require("debug"));
const debug = debug_1.default('forms:form');
class Form extends event_emitter_1.EventEmitter {
    constructor(form) {
        super();
        this.form = form;
        this.bootstrap();
    }
    get name() {
        return this.form.getAttribute(constants_1.FORM_NAME_KEY);
    }
    debug(...args) {
        debug(this.name, ...args);
    }
    bootstrap() {
        if (!this.name) {
            throw new Error(`Form is missing a ${constants_1.FORM_NAME_KEY} attribute`);
        }
        this.debug('bootstraping form');
        this.listener = event => {
            event.preventDefault();
            this.debug('submit listener called');
            this.submit()
                .then(() => {
                this.debug('submitted successfully');
                this.emit('submitted');
            })
                .catch(err => {
                this.debug('submit error', err);
                this.on('error', err);
            });
        };
        this.form.addEventListener('submit', this.listener);
        this.emit('init');
    }
    submit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.debug('submitting');
            this.emit('submitting');
            try {
                const token = yield captcha_1.captcha.instance.getToken();
                const data = new FormData(this.form);
                const response = yield fetch(`/-/forms/${this.name}`, {
                    method: 'post',
                    headers: {
                        Token: token,
                    },
                    body: data,
                });
                if (response.status !== 204) {
                    this.debug('response status is not 204, throwing error');
                    throw response;
                }
            }
            catch (e) {
                this.debug('catching error, emitting event and re-submitting');
                throw e;
            }
        });
    }
    remove() {
        if (!this.listener) {
            return;
        }
        this.form.removeEventListener('submit', this.listener);
        this.listener = undefined;
        this.emit('removed');
    }
    emit(event, data) {
        super.emit(event, data);
        this.form.dispatchEvent(new CustomEvent(event, { detail: data }));
    }
}
exports.Form = Form;
